import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import MyBatchFilter from "Pages/MyBatches/MyBatch/MyBatchFilter";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  GET_BATCHPL_STATUS,
  GET_BATCH_DETAILS,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import "./index.css";
import MyBatchStudentDetailTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailTab";
import MyBatchDetailsTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchDetailsTab";
import MyBatchTestsTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchTestsTab";
import MyBatchSyllabusTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchSyllabusTab";
import MyBatchLecturesTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchLecturesTab";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import {
  addDays,
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
} from "date-fns";
import { Badge, Button, Space } from "antd";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import styled from "styled-components";
import CourseSubjectListing from "Pages/MyBatches/MyBatch/SharedComponents/CourseSubjectListing";
import ChipsTagsAntdComponent from "utilFunctions/shared/AntdSharedComponents/ChipsTagsAntdComponent";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
import { FilterFilled } from "@ant-design/icons";
import { COLORS } from "utilFunctions/Constants/Constants";
import CrossIcon from "Assets/Icons/CrossIcon";
import { ChannelsHome } from "Pages/MyBatches/Channels/ChannelsHome";
import { useMyBatchContext } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";
import { myBatchEmitter } from "Pages/MyBatches/EmitterBus";
import { StyledDivHeader } from "Pages/DRS/DRSHeader";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { StyledTabs } from "Pages/MyBatchesAntd/MyBatchesAntd";
import { useMyBatchContext as useBatchContext } from "Pages/DRS/Context/MyBatchContext";
const CustomFilterFilled = styled<any>(FilterFilled)`
  color: ${COLORS.primary};
`;

export const MainDiv = styled<any>("div")`
  padding-left: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "44px" : "0px"};
  padding-right: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
`;
const SORT_ASC = "ASC";
const BranchStudentTableHeading = [
  { label: "Student Name", value: "studentName" },
  { label: "PSID", value: "psid" },
  { label: "Class Attendance", value: "classAttended" },
  { label: "Tests Attempted", value: "testCount" },
  { label: "Risk Segment | LOP%", value: "riskSegment" },
  { label: "Status", value: "status" },
  { label: "Followups", value: "followUpCounts" },
];

const MyBatchTestsHeading = [
  { label: "Test Name", value: "type" },
  { label: "Start Date-End Date", value: "startDate" },
  { label: "Format | Mode", value: "format" },
  { label: "Result Date", value: "resultDate" },
  { label: "Syllabus Status", value: "testSyllabusStatus" },
];

const TAB_LABEL_TO_KEY_MAP: Record<string, string> = {
  Channels: "1",
  "Student Details": "2",
  Syllabus: "3",
  Lectures: "4",
  Tests: "5",
  "Batch Details": "6",
};

function MyBatchMain() {
  const navigate = useNavigate();
  const { batchDetail } = useBatchContext();

  const {
    batchDetailsData,
    setbatchDetailsData,
    myBatchFilter,
    setMyBatchFilter,
    selectedTabIndex: selectedTabIndexInContext,
    setSelectedTabIndex: setSelectedTabIndexInContext,
    setMyBatchTestsTabState,
  } = useMyBatchContext();
  const [selectedTabIndex, setSelectedTabIndex] = useState<string>(
    selectedTabIndexInContext || "1"
  );
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const location = useLocation();
  const selectedSubjectFromNotification =
    location.state?.selectedSubject || "General";
  const { state } = location;
  const ToastDispatch = useContext(ToastContextDispatch);
  const userInfo = useContext<any>(UserInfoContext);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [filterState, setFilterState] = useState<any>(
    myBatchFilter || {
      segment: null,
      status: null,
      clazz: null,
      subjectList: null,
      lectureType: "Lectures",
      uptestType: "Upcoming Tests",
    }
  );
  const [testDetailsFilter, setTestDetailsFilter] = useState<any>(
    filterState?.testTypes || ""
  );
  const [chipShow, setChipShow] = useState<any>(
    filterState || {
      chipFieldName: null,
    }
  );
  const [dateRanges, setDateRanges] = useState([
    {
      startDate: new Date(
        format(
          setSeconds(setMinutes(setHours(subDays(new Date(), 15), 18), 30), 0),
          "yyyy-MM-dd"
        )
      ),
      endDate: new Date(
        format(
          setSeconds(setMinutes(setHours(addDays(new Date(), 0), 0), 30), 0),
          "yyyy-MM-dd"
        )
      ),
      key: "selection",
    },
  ]);
  const [testSyllabusStatus, setTestSyllabusStatus] = useState<any>([]);

  const [selectedCourseSyllabus, setSelectedCourseSyllabus] =
    useState<any>(null);
  const [batchDetailById, setBatchDetailById] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [sortColumn, setSortColumn] = useState<any>("student_name");
  const [batchId, setBatchId] = useState<string>("");
  const [subjectsList, setSubjectsList] = useState<selectInterface[]>([]);
  const [refresh, setRefresh] = useState<any>(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [lectureFilterListing, setLectureFilterListing] = useState<string[]>([
    "status",
    "subject",
    "date",
    "lectureType",
  ]);

  const { makeRequest: GetBatchDetailByBatchID } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setBatchDetailById(data["data"] || []);
        const newSubjectdata: any = [];
        data["data"].map((item: any) => {
          newSubjectdata.push({
            label: item.subj,
            value: item.subj,
            key: item.subj,
            courseId: item.courseId,
          });
        });
        setSubjectsList(newSubjectdata);
        setSelectedCourseSyllabus(data["data"][0]);
      } else {
        setBatchDetailById([]);
      }
    },
    (error: any) => {
      setBatchDetailById([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const { makeRequest: GetBranchDetailsData } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        setbatchDetailsData(data["data"]);
      } else {
        setbatchDetailsData(null);
      }
    },
    (error) => {
      setbatchDetailsData(null);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const setRedirectPath = (location: any) => {
    if (location && location.state && location.state.myBatchRedirectSelect) {
      const myBatchRedirectSelect = location.state.myBatchRedirectSelect;
      const key = TAB_LABEL_TO_KEY_MAP[myBatchRedirectSelect];
      if (key) {
        setSelectedTabIndex(key);
      }
    }
  };
  useEffect(() => {
    setRedirectPath(location);
    const batchId =
      location.pathname.split("/")[location.pathname.split("/").length - 1] ||
      "";
    if (batchId) {
      const batchUrl = `${BASE_URL}${GET_BATCH_DETAILS}?batchId=${batchId}`;
      GetBranchDetailsData(batchUrl);
      GetBatchDetailByBatchID(BASE_URL + GET_BATCHPL_STATUS + "/" + batchId); // issue #syllabus
      setBatchId(batchId);
      if (state && state.myBatchRedirectTab) {
        setActiveTab(state.myBatchRedirectTab);
      }
    }
  }, [state]);

  useEffect(() => {
    // Reset state if we switch to a different batch
    const storedBatchId = window.sessionStorage.getItem("lastBatchId");
    if (batchId && storedBatchId && batchId !== storedBatchId) {
      const clearedFilter = {
        segment: null,
        status: null,
        clazz: null,
        subjectList: null,
        lectureType: "Lectures",
        uptestType: "Upcoming Tests",
      };
      setFilterState(clearedFilter);
      setMyBatchFilter(clearedFilter);
    }
    if (batchId) {
      window.sessionStorage.setItem("lastBatchId", batchId);
    }
  }, [batchId]);

  useEffect(() => {
    setMyBatchFilter(filterState);
  }, [filterState]);

  useEffect(() => {
    if (selectedTabIndex) {
      setSelectedTabIndexInContext(selectedTabIndex);
    }
  }, [selectedTabIndex]);

  useEffect(() => {
    return () => {
      const shouldPersist = window.sessionStorage.getItem(
        "shouldPersistMyBatchTab"
      );
      if (!shouldPersist) {
        setSelectedTabIndexInContext("1");
        setMyBatchFilter(null);
        setMyBatchTestsTabState({
          selectedType: "PAST",
          pagination: {
            pageSize: 10,
            total: 0,
            pageSizeOptions: ["10", "50", "100"],
            showSizeChanger: true,
            current: 1,
          },
        });
      }
      window.sessionStorage.removeItem("shouldPersistMyBatchTab");
    };
  }, []);

  const isChecked = false;
  const updateSetItems = (label: string) => {
    if (label == "Non Lecture") {
      setLectureFilterListing(["status", "date", "lectureType"]);
    } else {
      setLectureFilterListing(["status", "subject", "date", "lectureType"]);
    }
  };
  const applyFilter = (filterStateObj: any) => {
    pushToDataLayerForGTM({
      event: "ag_sp_apply_performance_filter",
      STREAM: filterStateObj?.stream?.label ?? null,
      CLASS: filterStateObj?.clazz ?? null,
      BRANCH_NAME: filterStateObj?.branchName ?? null,
      FILTER_TYPE: Object.keys(filterStateObj)
        .filter((k) => filterStateObj[k] != null)
        .join(","),
    });
    setChipShow(filterStateObj);
    if (["Lectures", "Non Lecture"].includes(selectedTab.label)) {
      setRefresh(new Date().getMilliseconds());
      if (filterStateObj.lectureType === "Non Lecture") {
        delete filterStateObj.subject;
        if (
          filterStateObj.chipFieldName &&
          filterStateObj.chipFieldName.subject
        ) {
          delete filterStateObj.chipFieldName.subject;
        }
      }
      myBatchEmitter.emit("toggleTab", selectedTab.name, filterStateObj);
      return;
    }
    if (["Tests"].includes(selectedTab.label)) {
      myBatchEmitter.emit("toggleTab", selectedTab.name, { ...filterStateObj });
      return;
    }
    if (["Tests"].includes(selectedTab.label)) {
      if (filterStateObj?.testTypes) {
        setTestDetailsFilter(filterStateObj?.testTypes);
      } else {
        setTestDetailsFilter("");
      }
    }
  };
  const items = [
    {
      key: "1",
      name: "Channels",
      label: "Channels",
      value: "channels",
      children: (
        <ChannelsHome
          batchDetailsData={batchDetailsData}
          selectedSubject={selectedSubjectFromNotification}
        />
      ),
    },
    {
      key: "2",
      name: "Student Details",
      label: "Student Details",
      value: "studentDetails",
      filterListing: [],
      children: (
        <MyBatchStudentDetailTab
          tableHeading={BranchStudentTableHeading}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          screen={screen}
        />
      ),
    },
    {
      key: "3",
      name: "Syllabus",
      label: "Syllabus",
      value: "syllabus",
      filterListing: ["CourseSubject"],
      children: (
        <MyBatchSyllabusTab
          screen={screen}
          selectedCourseSyllabus={selectedCourseSyllabus}
          setSelectedCourseSyllabus={setSelectedCourseSyllabus}
          item={batchDetailById}
        />
      ),
    },
    {
      key: "4",
      name: "Lectures",
      label: "Lectures",
      value: "lectures",
      filterListing: lectureFilterListing,
      children: (
        <MyBatchLecturesTab
          selectedCourseSyllabus={selectedCourseSyllabus}
          screen={screen}
          filterState={filterState}
          setFilterState={setFilterState}
          refresh={refresh}
          setRefresh={setRefresh}
          dateRanges={dateRanges}
          batchDetailById={batchDetailById}
          applyFilter={applyFilter}
          subjects={subjectsList}
          filterListing={["status", "subjectList", "date", "lectureType"]}
        />
      ),
    },
    {
      key: "5",
      name: "Tests",
      label: "Tests",
      value: "Tests",
      children: (
        <MyBatchTestsTab
          tableHeading={MyBatchTestsHeading}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          screen={screen}
          testSyllabusStatus={testSyllabusStatus}
          setTestSyllabusStatus={setTestSyllabusStatus}
          testDetailsFilter={testDetailsFilter}
          batchId={batchId}
          batchDetailById={batchDetailById}
          testTypes={masters.testTypes}
          filterListing={["uptestType"]}
          setFilterState={setFilterState}
          batchDetailsData={batchDetailsData}
          batchDetail={batchDetail}
        />
      ),
    },
    {
      key: "6",
      name: "Batch Details",
      label: "Batch Details",
      value: "basicDetails",
      filterListing: [],
      children: <MyBatchDetailsTab screen={screen}></MyBatchDetailsTab>,
    },
  ];
  const handleClearAllFilter = () => {
    const clearedFilter = {
      stream: null,
      clazz: null,
      segment: null,
      status: null,
      subjectList: null,
      lectureType: "Lectures",
      uptestType: "Upcoming Tests",
    };
    updateSetItems("Lectures");
    setFilterState(clearedFilter);
    clearShowChipHandler();
    if (["Lectures", "Non Lecture"].includes(selectedTab.label)) {
      myBatchEmitter.emit("toggleTab", selectedTab.name, {});
      setDateRanges([
        {
          startDate: new Date(
            format(
              setSeconds(
                setMinutes(setHours(subDays(new Date(), 15), 18), 30),
                0
              ),
              "yyyy-MM-dd HH:mm:ss"
            )
          ),
          endDate: new Date(
            format(
              setSeconds(
                setMinutes(setHours(addDays(new Date(), 0), 18), 30),
                0
              ),
              "yyyy-MM-dd HH:mm:ss"
            )
          ),
          key: "selection",
        },
      ]);
      setRefresh(new Date().getMilliseconds());
      return;
    }
    if (["Tests"].includes(selectedTab.label)) {
      myBatchEmitter.emit("toggleTab", selectedTab.name, {
        uptestType:
          selectedTab.label === "Past Tests" ? "Past Tests" : "Upcoming Tests",
      });
      return;
    }
    resetHandler && resetHandler();
  };
  const clearShowChipHandler = () => {
    setChipShow({
      chipFieldName: null,
    });
  };
  const selectedTab: any = items?.find(
    (ele: any) => ele.key === selectedTabIndex
  );
  const newFilterState = JSON.parse(JSON.stringify(chipShow));
  // delete newFilterState.startDate;
  delete newFilterState.endDate;
  const chipsFields = newFilterState.chipFieldName;
  if (chipsFields && chipsFields.startDate) {
    chipsFields.startDate = chipsFields.startDate + " ~ " + chipsFields.endDate;
    delete chipsFields.endDate;
  }
  delete newFilterState.chipFieldName;
  if (selectedTab.label == "Upcoming Tests") {
    delete newFilterState["lectureType"];
  }
  const filterLength = Object.values(newFilterState).filter(
    (ele) => ele != null
  ).length;
  const resetHandler = () => {
    setDateRanges([
      {
        startDate: new Date(
          format(
            setSeconds(
              setMinutes(setHours(subDays(new Date(), 15), 18), 30),
              0
            ),
            "yyyy-MM-dd"
          )
        ),
        endDate: new Date(
          format(
            setSeconds(setMinutes(setHours(addDays(new Date(), 0), 0), 30), 0),
            "yyyy-MM-dd"
          )
        ),
        key: "selection",
      },
    ]);
    setFilterState({
      segment: null,
      status: null,
      testTypes: null,
      lectureType: "Lectures",
      uptestType: "Upcoming Tests",
    });
    if (["Tests"].includes(selectedTab.label)) {
      console.log("filters cleared");
      setTestDetailsFilter("");
    }
  };
  const Reset = ({ isFullScreen }: any) => {
    return (
      <>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <Button onClick={handleClearAllFilter}>Reset</Button>
        ) : (
          <>
            {isFullScreen ? (
              <Button onClick={handleClearAllFilter}>Reset</Button>
            ) : (
              <CrossIcon onClick={handleClearAllFilter}></CrossIcon>
            )}
          </>
        )}
      </>
    );
  };
  const FilterBtn = () => (
    <Badge
      count={filterLength}
      size={["xxl", "xl", "lg"].includes(screen) ? "default" : "small"}
    >
      <>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <Button
            size={["xxl", "xl", "lg"].includes(screen) ? "middle" : "small"}
            type="primary"
            onClick={() => {
              setIsDrawerOpen(true);
            }}
          >
            Filters
          </Button>
        ) : (
          <CustomFilterFilled
            onClick={() => {
              setIsDrawerOpen(true);
            }}
          />
        )}
      </>
    </Badge>
  );
  const onCloseHandler = (value: any) => {
    const newFilterState = JSON.parse(JSON.stringify(filterState));
    newFilterState[value] = null;
    applyFilter(newFilterState);
    setFilterState({
      ...filterState,
      [value]: null,
    });
  };
  console.log("render MyBatchMain", chipsFields, newFilterState);
  const HeaderCM = () => (
    <StyledDivHeader
      className="d-flex align-items-center justify-content-between"
      style={{
        background: "white",
      }}
    >
      <div className="d-flex align-items-center">
        <LeftArrow
          className={"cursorHoverCSS mr-1"}
          onClick={(e: any) => {
            e.preventDefault();
            setSelectedTabIndex("1");
            setSelectedTabIndexInContext("1");
            setMyBatchFilter(null);
            setMyBatchTestsTabState({
              selectedType: "PAST",
              pagination: {
                pageSize: 10,
                total: 0,
                pageSizeOptions: ["10", "50", "100"],
                showSizeChanger: true,
                current: 1,
              },
            });
            navigate("/admin/batches");
          }}
        />
        <Typography
          variant={["xxl", "xl"].includes(screen) ? "h4" : "h6"}
          color="black"
        >
          {`${batchDetailsData?.batchName} | ${batchDetailsData?.academicGroup}`}
        </Typography>
      </div>
      <div className="d-flex align-items-center gap-2">
        {filterLength != 0 && ["xxl", "xl", "lg"].includes(screen) && (
          <ChipsTagsAntdComponent
            filterState={removeEmptyFields(newFilterState)}
            chipsFields={chipsFields}
            onCloseHandler={onCloseHandler}
          ></ChipsTagsAntdComponent>
        )}
        {selectedTab?.filterListing && selectedTab?.filterListing.length ? (
          <Space>
            {selectedTab.label != "Syllabus" ? (
              <FilterBtn />
            ) : (
              <>
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <CourseSubjectListing
                    item={batchDetailById}
                    selectedCourseSyllabus={selectedCourseSyllabus}
                    selectedCourseSyllabusHandler={setSelectedCourseSyllabus}
                  ></CourseSubjectListing>
                ) : (
                  <FilterBtn />
                )}
              </>
            )}
            {filterLength != 0 && <Reset isFullScreen={false} />}
          </Space>
        ) : null}
      </div>
    </StyledDivHeader>
  );
  const onChange = (key: string) => {
    setSelectedTabIndex(key);
    setSelectedTabIndexInContext(key);
    clearAllStatesHandler();
    const tabname = Object.keys(TAB_LABEL_TO_KEY_MAP).find(
      (k: any) => TAB_LABEL_TO_KEY_MAP[k] === key
    );
    pushToDataLayerForGTM({
      event: "ag_sc_select_batch_details_tab",
      BATCH_ID: batchDetailById?.batchName ?? batchDetailsData?.batchName,
      TAB_NAME: tabname,
      USER_ROLE: userInfo?.fexRole,
      EMPLOYEE_ID: userInfo?.employeeId,
    });
    if (key === TAB_LABEL_TO_KEY_MAP["Tests"]) {
      pushToDataLayerForGTM({
        event: "ag_test_compliance_view_tests",
        TAB_NAME: "Tests",
        USER_ROLE: userInfo?.fexRole,
        BATCH_ID: batchDetailById?.batchName ?? batchDetailsData?.batchName,
      });
    }
  };
  const clearAllStatesHandler = () => {
    setFilterState({
      segment: null,
      status: null,
      testTypes: null,
    });
  };
  useEffect(() => {
    // If the tab specifically requires a reset, we can do it here, but generally
    // we want to persist filters if we go and come back.
    // In this app, many things use myBatchEmitter to toggle tabs.
  }, [selectedTabIndex]);

  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={isDrawerOpen}
        setOpen={setIsDrawerOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-start">
              {selectedTab.label != "Syllabus" && (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      applyFilter(filterState);
                      setIsDrawerOpen(false);
                    }}
                    className="m-0"
                  >
                    Apply
                  </Button>
                  <Reset isFullScreen={true} />
                </>
              )}
              <Button onClick={() => setIsDrawerOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <MyBatchFilter
          filterState={filterState}
          setFilterState={setFilterState}
          applyFilter={applyFilter}
          resetHandler={resetHandler}
          location={location}
          subjects={subjectsList}
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
          open={open}
          setOpen={setOpen}
          selectedTab={selectedTab}
          state={state}
          batchDetailsData={batchDetailsData}
          isChecked={isChecked}
          activeTab={activeTab}
          batchDetailById={batchDetailById}
          selectedCourseSyllabus={selectedCourseSyllabus}
          setRefresh={setRefresh}
          refresh={refresh}
          setSelectedCourseSyllabus={(val: any) => {
            setSelectedCourseSyllabus(val);
            setIsDrawerOpen(false);
          }}
          setChipShow={setChipShow}
          updateSetItems={updateSetItems}
        />
      </DrawerAntdComponent>
      <MainDiv screen={screen}>
        <HeaderCM />
        <StyledTabs
          activeKey={selectedTabIndex}
          defaultActiveKey={selectedTabIndex}
          items={items}
          onChange={onChange}
          destroyInactiveTabPane={true}
          isTabsContentHeightFull={true}
        />
      </MainDiv>
    </>
  );
}

export default MyBatchMain;
